import React from 'react';
import { useTranslation } from 'react-i18next';

import { PageTitle } from '../../../components/common/PageTitle/PageTitle';
import * as S from '../Legal.styles';

const href = window.location.href;
const noIndex = true;

const FileRetentionPolicyPage: React.FC = () => {
    const { t } = useTranslation();
  
    return (
      <>
        <PageTitle 
          title={t('head:aboutUsTitle')} 
          description={t('head:aboutUsDescription')} 
          url={href} 
          noIndex={noIndex} 
        />
        
        <S.H1 level={1}>File Retention Policy</S.H1>
        <S.ContentRight>Last Updated: 30 June 2024</S.ContentRight>

        <S.Section>
          <S.H2 level={2}>File Retention Policy</S.H2>
          <S.Paragraph>OMR Quiz App allows customers to upload files for conversation or other document operations. This policy outlines how we treat retention of those files.</S.Paragraph>
          <S.Paragraph>All files uploaded to the website are retained for a maximum of 24 hours before being deleted automatically thereafter. These files are not accessible to any person other than the person who uploads them.</S.Paragraph>
          <S.Paragraph><em>n.b. The above file retention policy outlines how we usually deal with the retention of files for accounts. This policy does not affect the ultimate right of OMR Quiz to request an OMR Quiz account holder to remove any or all content as outlined in section 5.2 of our Terms of Service.</em></S.Paragraph>
        </S.Section>
      </>
    );
  };

export default FileRetentionPolicyPage;